import { Logo } from '../../shared/ui/Logo.js';
import { SignInForm } from './SignInForm.js';
import './login.css';

export function LoginPage() {
  return (
    <div className="login">
      <div className="login__card">
        <div className="login__brand">
          <Logo suffix="Analytics" />
        </div>

        <h1 className="login__title">Connexion</h1>
        <p className="login__sub">Accédez à la mesure, aux parcours et aux guidances proposées.</p>

        <SignInForm onSignedIn={() => undefined} />
      </div>
    </div>
  );
}
